import { render, staticRenderFns } from "./QNewWritersDrilldown.vue?vue&type=template&id=1bbec02c&scoped=true&"
import script from "./QNewWritersDrilldown.vue?vue&type=script&lang=js&"
export * from "./QNewWritersDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbec02c",
  null
  
)

export default component.exports